import { render, staticRenderFns } from "./FavouritesShare.vue?vue&type=template&id=66dc0791&"
import script from "./FavouritesShare.vue?vue&type=script&lang=js&"
export * from "./FavouritesShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('66dc0791', component.options)
    } else {
      api.reload('66dc0791', component.options)
    }
    module.hot.accept("./FavouritesShare.vue?vue&type=template&id=66dc0791&", function () {
      api.rerender('66dc0791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/FavouritesShare.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FavouritesShare.vue
// module id = 168
// module chunks = 6